document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.c-tabs').forEach(initTab);
});

function initTab(tabContainer) {
  const selectBox = tabContainer.querySelector('.tab-options');
  const selectItems = selectBox?.querySelectorAll('.tab-option');
  const titles = tabContainer.querySelectorAll('.tab-title');
  const items = tabContainer.querySelectorAll('.tab-item');

  let resizeObserver;

  tabContainer.addEventListener('click', function (e) {
    if (e.target.classList.contains('tab-link')) {
      const tabId = e.target.parentNode.dataset.tab;
      setActiveItem(tabId);
      selectBox.value = tabId;
    }
  });

  selectBox.addEventListener('change', function () {
    setActiveItem(this.value);
  });

  function setActiveItem(tab) {
    let activeItem;

    for (const item of [...titles, ...items, ...selectItems]) {
      const isActiveTab = item.dataset.tab === tab;
      item.dataset.active = isActiveTab.toString();

      if (item.classList.contains('tab-item' || 'tab-option') && isActiveTab) {
        activeItem = item;
      }
    }

    if (activeItem) {
      const itemContent = activeItem.querySelector('.c-tab-item-content');
      if (!itemContent) return;

      if (resizeObserver) resizeObserver.disconnect();

      resizeObserver = new ResizeObserver((entries) => {
        for (const entry of entries) {
          const height = entry.target.offsetHeight / 16;
          tabContainer.style.setProperty('--content-height', `${height}rem`);
        }
      });

      resizeObserver.observe(itemContent);
    }
  }
}
